module.exports = __webpack_public_path__ + "static/media/vps-n8n.9446b32e.png";